

function loadAll() {
  $(document).ready(function() {
    var winW = $(window).width();

    // lazy loads elements with default selector as '.lozad'
    const observer = lozad();
    observer.observe();

    $(window).load(function() {
      resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), true);
    });

    $(window).resize(function() {
      resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), false);
    });

    $('header .icons li .search').click(function() {
      $('header .big-search').toggleClass('show');
      $('header .black-search').toggleClass('show');
    });

    $('header .big-search .cerrar-big-search').click(function() {
      $('header .big-search').toggleClass('show');
      $('header .black-search').toggleClass('show');
    });

    $('body:not(.template-cart) header .icons li .cart').click(function() {
      $('#minicart').addClass('show');
    });

    $('#minicart .cerrar').click(function() {
      $('#minicart').removeClass('show');
    });

    $('header .show-menu').click(function() {
      $('nav').addClass('show');
    });

    $('header nav .cerrar').click(function() {
      $('nav').removeClass('show');
    });

    $('.deon > h3').each(function() {
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    });

    $('.deon h3').each(function() {
      if ($(this).text().trim() === 'Descripción') {
        $(this).addClass('active');
        $(this).next('.hide-info').addClass('show');
      } else {
        $(this).removeClass('active');
        $(this).next('.hide-info').removeClass('show');
      }
    });
    
    $('.deon h3').click(function() {
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });

    $('.pro-int .ver').click(function() {
      $('.pro-int .gallery').addClass('show');
    });

    $('.pro-int .gallery .cerrar').click(function() {
      $('.pro-int .gallery').removeClass('show');
    });

    $('.product .des-int .inner > h3').each(function() {
      $(this).addClass('h3-int');
      $(this).nextUntil('h3').wrapAll('<div class="contacto"></div>')
    });

    $('.pro-int .contactar').click(function() {
      $('.pro-int .form').addClass('show');
    });

    $('.pro-int .form .cerrar').click(function() {
      $('.pro-int .form').removeClass('show');
    });

    // Collection
    if (winW < 830) {
      $('.facets__heading').click(function(){
        $(this).toggleClass('clicked');
        $('.template-collection .facets__disclosure').slideToggle(200);
      });
    }

    // Pop Up
    $('#popup .cerrar').click(function() {
      $('#popup').removeClass('show');
    });

    if ( winW < 830 ) {
      $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
      $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
        $(this).toggleClass('active');
        $(this).parent().siblings().children('.sub-menu').removeClass('show');
        $(this).parent().children('.sub-menu').toggleClass('show');
      });
      $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
      $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
        $(this).toggleClass('active');
        $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
        $(this).parent().children('.sub-sub-menu').toggleClass('show');
      });
    }

    /**
     * Escucha permanente para agregar productos, funciona para snippet
     * product-item.liquid
     *
     * @param object this  Contiene el objeto del elemento cliqueado.
     */
    $('body').on('click', '.item .addcart', function() {
      let proVar = $(this).data('product-id');
      var proQt = $(this).siblings('.sec-cantidad').children().children('input').val();
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: {
          quantity: proQt,
          id: proVar
        },
        success: function(data) {
        },
        error: function(data) {
          if (data.status == 422) {
            $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
          }
        },
        async: false
      }).always(function() {
        update_mini_cart(true);
      });
    });

    update_mini_cart();
  });

  /**
   * Escucha permanente para borrar producto del mini carro
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '#minicart i.delete-prod', function() {
    var var_this = this;
    $.post(window.Shopify.routes.root + 'cart/update.js',
      `updates[${$(var_this).data('id')}]=0`
    ).always(function() {
      update_mini_cart(false, false);
      $(var_this).css("margin", "0").parent().parent().slideUp(200);
    });
  });
  $('body').on('click', '#minicart div.delete-prod', function() {
    var var_this = this;
    $.post(window.Shopify.routes.root + 'cart/update.js',
      `updates[${$(var_this).data('id')}]=0`
    ).always(function() {
      update_mini_cart(false, false);
      $(var_this).css("margin", "0").parent().parent().slideUp(200);
    });
  });


  $('body').on('click', '#minicart .inc', function() {
    var var_this = this;
    let parentElement = this.parentElement;
    let quantity = parentElement.querySelector('input').value;
 
    parentElement.querySelector('input').value = +quantity+1
    $.post(window.Shopify.routes.root + 'cart/update.js',
      `updates[${$(parentElement).data('id')}]=${+quantity+1}`
    )

    setTimeout( function(){
      update_mini_cart(true);
    }, 500)
  });

  $('body').on('click', '#minicart .dec', function() {
    var var_this = this;
    let parentElement = this.parentElement;
    let quantity = parentElement.querySelector('input').value;

    parentElement.querySelector('input').value = +quantity-1
    $.post(window.Shopify.routes.root + 'cart/update.js',
      `updates[${$(parentElement).data('id')}]=${+quantity-1}`
    ).always(function() {
      if (quantity <= 0) {
      update_mini_cart(false, false);
      $(var_this).css("margin", "0").parent().parent().slideUp(200);
      }else{
        setTimeout( function(){
          update_mini_cart(true);
        }, 500)
      }
    });
  });
}




function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

defer(function () { loadAll(); }, 0);

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 * 
 */

function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var vendor     = data.items[i]["vendor"];
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      console.log({ i });
      console.log({ imagen });
        /*       var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>"; */
        var proMini    = `
        <li>
          <div class='left'><img src='${imagen}' alt='${titulo}' /></div>
          <div class='right'>
          <h3>${vendor}</h3>
            <h4>${titulo}</h4>
            <h5>$${precio}</h5>
            <div class='td-quantity' data-id='${varianteID }'> 
              <div class='inc button'><span>+</span></div> 
              <input type='number' class='cart__quantity-selector' name='updates[]' id='updates_${ varianteID }' value='${ cantidad }' min='0' aria-label='Cantidad'> 
              <div class='dec button'><span>-</span></div> 
            </div>
            <div class='delete-prod' data-id='${varianteID }'>Quitar del carro</div>
          </div>
          `
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var free = 39990;
    var total1 = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2) : '0';
    var total = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var falta1 = free - total1;
    var falta = falta1 ? falta1.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var porcentaje = (total1 * 100) / free;
    var itemcount = data.item_count;
    console.log("%",porcentaje)
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    $("#minicart .middle .container-porcentaje .barra-total .barra-lleva").css("width", porcentaje + '%')
    if (show) {
      $('#minicart').addClass('show');
    }
    if (falta > 0) {
      $(".casi .falta").text('$' + falta);
      $('.casi .aun').show(1);
      $('.casi .listo').hide(1);
      $('.casi .barra .linea2').css('width', porcentaje + '%');
      $('.casi .barra .camion').css('left', porcentaje + '%');
    } else {
      $('.casi .aun').hide(1);
      $('.casi .listo').show(1);
      $('.casi .barra .linea2').css('width', '100%');
      $('.casi .barra .camion').css('left', '100%');
    }
  }, 'json');
}


/**
 * Devuelve el stock de la variante seleccionada
 *
 * @param object stock  Inventario de la ariante
 */

 function get_stock(stock = 0) {
   if (stock == 0) {
     $('.remain p').html('Producto agotado');
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == undefined ) {
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == 1) {
     $('.remain p').html('Queda sólo ' + stock + ' unidad');
     $('#sobre-agregar').fadeOut(100);
   } else if (stock > 1 && stock < 6) {
     $('.remain p').html('Quedan sólo ' + stock + ' unidades');
     $('#sobre-agregar').fadeOut(100);
   } else {
     $('.remain p').html('');
     $('#sobre-agregar').fadeOut(100);
   }
 }

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
// function defer(method) {
//    if (window.jQuery) {
//      method();
//    } else {
//      setTimeout(function() { defer(method) }, 50);
//    }
// }
// defer(function () {
// function quantity_elements(ajax = false) {
//   if (ajax) {
//     $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-recommendations .sec-cantidad input');
//     $('.product-recommendations .sec-cantidad').each(function() {
//       var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
//       btnUp.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue >= max) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue + 1;
//         }
//         spinner.find("input").val(newVal);
//         spinner.find("input").trigger("change");
//       });
//       btnDown.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue <= min) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue - 1;
//         }
//         spinner.find("input").val(newVal);
//         $(spinner).parent().find(".addcart").data("qt", newVal);
//         spinner.find("input").trigger("change");
//       });
//     });
//   } else {
//     $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.sec-cantidad input');
//     $('.sec-cantidad').each(function() {
//       var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
//       btnUp.click(function() {
//         var oldValue = parseFloat(input.val());
//         if (oldValue >= max) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue + 1;
//         }
//         spinner.find("input").val(newVal);
//         spinner.find("input").trigger("change");
//       });
//       btnDown.click(function() { 
//         var oldValue = parseFloat(input.val());
//         if (oldValue <= min) {
//           var newVal = oldValue;
//         } else {
//           var newVal = oldValue - 1;
//         }
//         spinner.find("input").val(newVal);
//         $(spinner).parent().find(".addcart").data("qt", newVal);
//         spinner.find("input").trigger("change");
//       });
//     });
//   }
// }
// }, 0);

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

function resizeHeader(barraH = 0, headerH = 0, infoH = 0, scroll = true) {
  if ( $(window).width() > 830 ) {
    $('body').css('padding-top', barraH + headerH);
    $('header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', barraH);
        }
        if ($(window).scrollTop() > 300) {
          $('.nav-collection').addClass('fix');
        } else {
          $('.nav-collection').removeClass('fix');
        }
      });
    }
  } else {
    $('body').css('padding-top', barraH + headerH);
    $('header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH) {
          $('header').addClass('fix');
          $('header').css('top', 0);
        } else {
          $('header').removeClass('fix');
          $('header').css('top', barraH);
        }
        if ($(window).scrollTop() > 200) {
          $('.nav-collection').addClass('fix');
        } else {
          $('.nav-collection').removeClass('fix');
        }
      });
    }
  }
}

// defer(function () { 
//   $(document).ready(function () {
//     $(".header-town-selector-modal .guardar-region").on("click", function () {
//       let comunaSave = localStorage.getItem("comuna");
//       console.log({ comunaSave });
//       if(comunaSave === "Cerrillos" || comunaSave === "Cerro Navia" || comunaSave === "Conchalí" || comunaSave === "El Bosque" || comunaSave === "Estación Central" || comunaSave === "Huechuraba" || comunaSave === "Independencia" || comunaSave === "La Cisterna" || comunaSave === "La Florida" || comunaSave === "La Granja" || comunaSave === "La Pintana" || comunaSave === "La Reina" || comunaSave === "Las Condes" || comunaSave === "Lo Barnechea" || comunaSave === "Lo Espejo" || comunaSave === "Lo Prado" || comunaSave === "Lo Prado" || comunaSave === "Macul" || comunaSave === "Maipú" || comunaSave === "Ñuñoa" || comunaSave === "Pedro Aguirre Cerda" || comunaSave === "Peñalolén" || comunaSave === "Providencia" || comunaSave === "Pudahuel"  || comunaSave === "Puente Alto" || comunaSave === "Quilicura" || comunaSave === "Quinta Normal"  || comunaSave === "Recoleta" || comunaSave === "Renca" || comunaSave === "San Bernardo" || comunaSave === "San Joaquín"  || comunaSave === "San Miguel" || comunaSave === "San Ramón"  || comunaSave === "Santiago" || comunaSave === "Vitacura" ) {
//         $('.product .right .icons .container-tag').addClass("show");
//         $('.product .congelados-product').removeClass("hide");
//         $('.product .text-product').addClass("hide");
//         $('.featured-collection ul .item .img .icons .solo-rm').addClass("show");
//         $('.featured-collection ul .item.congelados').removeClass('after-congelados');
//         console.log("yes")
//       } else if (comunaSave == null) {
//         console.log('null');
//         $('.product .text-product').addClass("hide");
//       } else {
//         $('.product .right .icons .container-tag').removeClass("show");
//         $('.product .congelados-product').addClass("hide");
//         $('.product .text-product').removeClass("hide");
//         $('.featured-collection ul .item .img .icons .solo-rm').removeClass("show");
//         $('.featured-collection ul .item.congelados').addClass('after-congelados');
//         console.log("no")
//       }
//     });
//   });
// }, 0);

